import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "投诉编号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "id", $$v);
      },
      expression: "searchForm.id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "投诉分类"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.complaintTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "complaintTypeId", $$v);
      },
      expression: "searchForm.complaintTypeId"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.complaintTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chName,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "被投诉人手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.complainedUserPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "complainedUserPhone", $$v);
      },
      expression: "searchForm.complainedUserPhone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "投诉人手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userPhone", $$v);
      },
      expression: "searchForm.userPhone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "操作人"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.adminId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "adminId", $$v);
      },
      expression: "searchForm.adminId"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "状态"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "待处理",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "搁置",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "已处理",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          complaintTypeId: "",
          adminId: "",
          status: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "create",
      label: "投诉时间",
      width: "100px"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "complaintType",
      label: "投诉分类",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(scope.row.complaintType))]), scope.row.imCount == 0 ? _c("el-tag", [_vm._v("消息数：" + _vm._s(scope.row.imCount) + " ")]) : _c("el-tag", {
          attrs: {
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.goChatRecord(scope.row);
            }
          }
        }, [_vm._v("消息数：" + _vm._s(scope.row.imCount) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "reason",
      width: "300",
      label: "投诉理由"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "投诉人",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          user = _ref$row.user;
        return [_c("wlc-image", {
          attrs: {
            src: user.avatar,
            width: "60",
            enlarged: false,
            compression: true,
            to: "/user/list?phone=".concat(user.phone)
          }
        }), _c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-pop-radar-chart", {
          attrs: {
            info: user.userScore,
            type: user.user_type
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "被投诉人",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var _ref2$row = _ref2.row,
          otherUserInfo = _ref2$row.otherUserInfo,
          complainedUser = _ref2$row.complainedUser;
        return [_c("wlc-image", {
          attrs: {
            src: complainedUser.avatar,
            width: "60",
            enlarged: false,
            compression: true,
            to: "/user/list?phone=".concat(complainedUser.phone)
          }
        }), _c("wlc-user-pop", {
          attrs: {
            info: otherUserInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-pop-radar-chart", {
          attrs: {
            info: complainedUser.userScore,
            type: complainedUser.user_type
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "complainedTotal",
      label: "投诉人数",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", {
          staticStyle: {
            cursor: "pointer"
          },
          on: {
            click: function click($event) {
              return _vm.setFilter(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.complainedTotal))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "imgs",
      label: "投诉凭证",
      width: "143"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.imgs, function (item, index) {
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: scope.row.imgs,
              width: "50",
              compression: true
            }
          });
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      prop: "remark"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 2 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已处理 ")]) : _vm._e(), scope.row.status == 1 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("搁置 ")]) : _vm._e(), scope.row.status == 0 ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("待处理 ")]) : _vm._e(), scope.row.issueReward == 1 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("已奖励 ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "adminUser.name",
      label: "操作人",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "source",
      label: "投诉来源",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.source == 1 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("房源 ")]) : _vm._e(), scope.row.source == 2 ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("Lifestyle ")]) : _vm._e(), scope.row.source == 3 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("二手 ")]) : _vm._e(), scope.row.source == 4 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("个人详情 ")]) : _vm._e(), scope.row.source ? _c("div", {
          staticStyle: {
            "margin-top": "4px",
            "font-size": "13px"
          }
        }, [scope.row.source == 1 ? _c("a", {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://www.wellcee.com/rent-apartment/".concat(scope.row.sourceObjId)
          }
        }, [_vm._v("查看详情")]) : _vm._e(), scope.row.source == 2 ? _c("a", {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://www.wellcee.com/lifestyle/title?id=".concat(scope.row.sourceObjId)
          }
        }, [_vm._v("查看详情")]) : _vm._e(), scope.row.source == 3 ? _c("a", {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://www.wellcee.com/second-hand/title?id=".concat(scope.row.sourceObjId)
          }
        }, [_vm._v("查看详情")]) : _vm._e(), scope.row.source == 4 ? _c("a", {
          staticClass: "link",
          attrs: {
            target: "_blank",
            href: "https://www.wellcee.com/index/user/personal?id=".concat(scope.row.sourceObjId)
          }
        }, [_vm._v("查看详情")]) : _vm._e()]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "id",
      label: "投诉编号",
      width: "90"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 0 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setComplaintStatus(scope.row.id, 1, scope.row.user);
            }
          }
        }, [_vm._v("搁置 ")]) : _vm._e(), scope.row.status == 0 || scope.row.status == 1 ? _c("el-button", {
          staticClass: "xg",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setComplaintStatus(scope.row.id, 2, scope.row.user);
            }
          }
        }, [_vm._v("设为已处理 ")]) : _vm._e(), scope.row.issueReward == 0 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.issueReward(scope.row);
            }
          }
        }, [_vm._v("奖励 ")]) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "备注",
      width: "300px",
      visible: _vm.remarkDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.setComplaintRemark.apply(null, arguments);
      }
    },
    model: {
      value: _vm.remarkValue,
      callback: function callback($$v) {
        _vm.remarkValue = $$v;
      },
      expression: "remarkValue"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setComplaintRemark
    }
  }, [_vm._v(" 确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };